export class RefundAlreadyExists extends Error {
  public constructor() {
    super()

    this.message = 'errors.alreadyExists'
  }
}
